import { IBlockchainEntity, ChainID } from '@ankr.com/chains-list';

import { getChainName as getFallbackChainsName } from 'uiKit/utils/metatags';

import { getChainLabel } from './getChainLabel';
import { getCustomLabelForChainsCornerCases } from './getCustomLabelForChainsCornerCases';

export const getChainName = (
  chain: IBlockchainEntity,
  shouldAvoidFormatting = true,
) => {
  if (chain.id === 'aapi_v2' || chain.id === ChainID.MULTICHAIN) {
    return 'Advanced API';
  }

  const chainId = chain.id as ChainID;

  const fallBackName = getFallbackChainsName(chainId);

  const label = getChainLabel(fallBackName, chain);

  const isZkVerifyTestnet =
    chain.id === ChainID.ZKVERIFY_VFLOW_PARACHAIN_TESTNET ||
    chain.id === ChainID.ZKVERIFY_VOLTA_TESTNET;

  const name = getCustomLabelForChainsCornerCases({
    chainId,
    label,
    shouldAvoidFormatting: shouldAvoidFormatting && isZkVerifyTestnet,
  });

  return name;
};
